import React from "react";
import { Textarea, TextareaProps, styles as ui } from "stories/Admin";
import {
  isJummahInfoTooLong,
  JUMMAH_INFO_TV_HINT,
  jummahInfoLimit,
} from "./jummahInfoLimit";

type JummahInfoTextareaProps = Omit<
  TextareaProps,
  "value" | "maxChars" | "softLimit"
> & {
  value: string;
  /** Antall jummah-tider moskeen har (etter lagring). */
  jummahCount: number;
};

/**
 * Tekstfelt for jummah-teksten med teller «N / L» og en myk advarsel når
 * teksten blir kuttet på TV-skjermen. Lagring er fortsatt lov.
 */
const JummahInfoTextarea = React.forwardRef<
  HTMLTextAreaElement,
  JummahInfoTextareaProps
>(({ value, jummahCount, help, ...rest }, ref) => {
  const tooLong = isJummahInfoTooLong(value, jummahCount);
  return (
    <Textarea
      ref={ref}
      {...rest}
      value={value}
      maxChars={jummahInfoLimit(jummahCount)}
      softLimit
      help={
        tooLong ? <span className={ui.warnt}>{JUMMAH_INFO_TV_HINT}</span> : help
      }
    />
  );
});
JummahInfoTextarea.displayName = "JummahInfoTextarea";

export default JummahInfoTextarea;
